import { action, transaction, observable } from 'mobx'

export default (BaseClass) => class ContractFilmsState extends BaseClass {
  @action createContractItem (item) {
    this.requester.call('/contractitems', 'post', item).then((res) => {
      if (!this.cv.contractitems) {
        this.cv.contractitems = []
      }
      this.cv.contractitems.push(res.data)
    }).then((actualize) => {
      this.reactualizeContractItem(item)
    }).then((saved) => {
      this.addMessage('successfully saved', 'success', 2000)
    }).catch(this.onRequesterError.bind(this))
  }

  @action updateContractItem (item) {
    this.requester.call(`/contractitems/${item.id}`, 'put', item).then((res) => {
      transaction(() => {
        const existing = this.cv.contractitems.find((i) => (i.id === item.id))
        this.cv.contractitems.remove(existing)
        this.cv.contractitems.push(res.data)
      })
    }).then((actualize) => {
      this.reactualizeContractItem(item)
    }).then((saved) => {
      this.addMessage('successfully saved', 'success', 2000)
    }).catch(this.onRequesterError.bind(this))
  }

  @action removeContractItem (item) {
    this.requester.call(`/contractitems/${item.id}`, 'delete', item).then((res) => {
      this.cv.contractitems.remove(item)
    }).then((actualize) => {
      this.reactualizeContractItem(item)
    }).then((saved) => {
      this.addMessage('successfully saved', 'success', 2000)
    }).catch(this.onRequesterError.bind(this))
  }

  @action reactualizeContractItem (item) {
    const url = this.router.params.entityname === 'contracts'
      ? `/contractitems?filter={"contract_id":"${item.contract_id}"}`
      : `/contractitems?filter{"film_id":"${item.film_id}"}`

    this.requester.call(url).then((res) => {
      res.data.forEach((i) => (i.limits = i.limits || []))
      this.cv.contractitems = res.data
    }).catch(this.onRequesterError.bind(this))
  }
}
